module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-22-81486c2547847ccf58b280ef08ed4b1f.svg";